import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, ArrowLeft } from 'lucide-react';
import { DocumentRequestsSettings } from '../Settings/DocumentRequestsSettings';

export const DemandesRecurrentesPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="space-y-6">
            <header className="flex items-center gap-3">
                <button onClick={() => navigate(-1)} className="p-2.5 rounded-xl border border-border text-content-muted hover:text-content hover:bg-surface-soft transition-all">
                    <ArrowLeft size={18} />
                </button>
                <div>
                    <h1 className="text-3xl font-bold tracking-tight text-content flex items-center gap-2"><ClipboardList size={24} /> Demandes récurrentes</h1>
                    <p className="text-content-muted mt-1">Toutes les Démarches client envoyées à vos contacts, tous modèles confondus.</p>
                </div>
            </header>
            <DocumentRequestsSettings />
        </div>
    );
};

export default DemandesRecurrentesPage;
